export const columnData = {
  Delete: { name: 'Eliminar', widthCol: '5%' },
  Name: { name: 'Nombre de categoría', widthCol: '20%' },
  Description: { name: 'Descripción', widthCol: '40%' },
  ContributionPerc: { name: 'Por. de contribución', widthCol: '15%' },
  FromAge: { name: 'Edad desde', widthCol: '10%' },
  ToAge: { name: 'Edad hasta', widthCol: '10%' },
  Edit: { name: 'Editar', widthCol: '5%' }
}
